import React from 'react';
import { Icon } from '@iconify/react';
import { HighlightedTextIcon } from 'components/molecules';
import { AboutSectionContentProps } from 'components/organisms/About/types';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';

const Text = () => (
  <>
    Saat ini saya sedang bekerja sebagai freelance <span className="font-bold text-gray-800">fullstack developer</span> dan <span className="font-bold text-gray-800">UI/UX designer</span>. Saya sangat suka menggunakan
    <HighlightedTextIcon as="a" href="https://ui.shadcn.com/" className="mx-2" icon={<img src="/img/shadcn.svg" alt="ShadCN" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">ShadCN/UI</span>
    </HighlightedTextIcon>
    {' '}dan
    <HighlightedTextIcon as="a" href="https://tailwindcss.com" className="mx-2" icon={<Icon icon={tailwindcssIcon} />}>
      <span className="font-bold text-gray-800">TailwindCSS</span>
    </HighlightedTextIcon>
    {' '}dan
    <HighlightedTextIcon as="a" href="https://reactjs.org" className="mx-2" icon={<Icon icon={reactIcon} />}>
      <span className="font-bold text-gray-800">React</span>
    </HighlightedTextIcon>
    . Saya juga memiliki pengalaman dengan <HighlightedTextIcon as="a" href="https://nextjs.org/" className="mx-2" icon={<img src="/img/nextjs.svg" alt="Next.js" className="w-5 h-5" />}>
      <span className="font-bold text-gray-800">Next.js</span>
    </HighlightedTextIcon>. Saya telah bekerja dengan alat-alat ini selama sekitar <span className="font-bold text-gray-800">2 tahun</span> dan saya percaya diri dalam membangun aplikasi menggunakan mereka. Saya pernah magang sebagai web developer di <a className="font-bold text-gray-800" href="https://weabers.com/" target="_blank" rel="noopener noreferrer">Weabers</a> (<img src="/img/weabers.avif" alt="Weabers" className="inline w-6 h-4 ml-1" />). Saya juga seorang <span className="font-bold text-gray-800">penggemar olahraga</span> <img src="/img/sports.svg" alt="sports" className="inline w-5 h-5 mx-1" /> dan seorang <span className="font-bold text-gray-800">gamer</span> <img src="/img/gamer.svg" alt="gamer" className="inline w-5 h-5 ml-1" />.
  </>
);

const about: AboutSectionContentProps = {
  text: <Text />,
};

export default about;
